import { TECH_REVENUE_PER_HOUR_ID } from "../../../helpers/derivedMetricIds";

/** Whether a card's metric rows include Technicians' Revenue per Hour. */
export const hasRphMetric = (rows) => (rows || []).some((r) => r && r.metricId === TECH_REVENUE_PER_HOUR_ID);

/** The line under the goal box: what the number is while it is set, and what
    happens when it is cleared. */
export const derivedGoalNote = (goal) => (
  Number(goal) > 0
    ? "The “of $…” figure and the bar on this card read against this goal. Clear it to go back to the company’s own goal."
    : "Blank uses the goal on the company’s Revenue per Hour metric, if it has one. Type a number to set this card’s own."
);
